export enum TYPICAL_ERROR_ENUM {
  GREEN = 'green',
  YELLOW = 'yellow',
  RED = 'red',
}
